export default __webpack_public_path__ + "static/media/NunitoSans-SemiBoldItalic.1df0250c.woff";